import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';
import { PaginationConst } from '../constants/AppConstant';

export interface WhatsappPaymentReminderRow {
  id: string;
  debitId: string;
  reminderType: string;
  borrowerId: string;
  borrowerName?: string;
  whatsappNumber: string;
  debitType?: string;
  interestRate?: number;
  monthlyInterestAmount?: number | null;
  outstanding?: number;
  paymentDay?: number | null;
  dueDate?: string;
  amountDue?: number | null;
  templatePaymentDetails?: string;
  templateBody1?: string;
  templateImageUrl?: string;
  status: string;
  batchRunDate?: string;
  approvedBy?: string;
  approvedAt?: string;
  rejectedBy?: string;
  rejectedAt?: string;
  rejectionReason?: string;
  sentAt?: string;
  /** JSON body sent to Zixflow (no API key). */
  providerRequestPayload?: string;
  providerRequestAt?: string;
  providerResponseAt?: string;
  providerResponse?: string;
  providerError?: string;
  createdDate?: string;
}

export interface WhatsappReminderPage {
  content: WhatsappPaymentReminderRow[];
  totalElements: number;
  totalPages?: number;
  size?: number;
  number?: number;
}

export async function listWhatsappPaymentReminders(
  page: number = 0,
  pageSize: number = PaginationConst.PAGE_SIZE,
  status?: string
): Promise<WhatsappReminderPage> {
  let qs = `page=${page}&size=${pageSize}`;
  if (status && status !== 'ALL') {
    qs += `&status=${encodeURIComponent(status)}`;
  }
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/whatsapp-payment-reminders?${qs}`,
  });
  return response.data as WhatsappReminderPage;
}

export async function runWhatsappReminderBatch(dateIso?: string): Promise<{ created: number; batchRunDate: string }> {
  const q = dateIso ? `?date=${encodeURIComponent(dateIso)}` : '';
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/whatsapp-payment-reminders/run-batch${q}`,
    data: {},
  });
  return response.data;
}

export async function approveWhatsappReminder(id: string): Promise<WhatsappPaymentReminderRow> {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/whatsapp-payment-reminders/${id}/approve`,
    data: {},
  });
  return response.data as WhatsappPaymentReminderRow;
}

export async function rejectWhatsappReminder(id: string, reason?: string): Promise<WhatsappPaymentReminderRow> {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/whatsapp-payment-reminders/${id}/reject`,
    data: { reason: reason || undefined },
  });
  return response.data as WhatsappPaymentReminderRow;
}

export async function sendWhatsappReminder(id: string): Promise<WhatsappPaymentReminderRow> {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/whatsapp-payment-reminders/${id}/send`,
    data: {},
  });
  return response.data as WhatsappPaymentReminderRow;
}

export async function approveAndSendWhatsappReminder(id: string): Promise<WhatsappPaymentReminderRow> {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/whatsapp-payment-reminders/${id}/approve-and-send`,
    data: {},
  });
  return response.data as WhatsappPaymentReminderRow;
}
